var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"150px"}},[_c('h1',[_vm._v("Well done!")]),_c('h2',{staticStyle:{"margin-top":"70px"}},[_vm._v(" "+_vm._s(_vm.$t('繳交成功'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }